import styled from 'styled-components'

const MyAssetStyled = styled.div`
  .top-lending {
    display: flex;
    justify-content: space-between;
    padding-bottom: 20px;
    .search-horse-input {
      height: 34px;
    }
    .lending-search {
      display: flex;
      gap: 20px;
    }
    .title-asset {
      font-size: 24px;
      line-height: 20px;
    }
  }
`

export default MyAssetStyled
